<script setup>
import { getCurrentInstance, ref } from 'vue';
import ExportModal from '../views/admin/components/ExportModal.vue';

import { format } from 'date-fns';
import { useToast } from 'primevue/usetoast';
import axios from 'axios';
const totalRecords = ref(0);
const toast = useToast();
const { proxy } = getCurrentInstance();
const exportModal = ref(false);
const API_URL = import.meta.env.VITE_APP_SYNC;

// Thêm các biến cho popup chọn thời gian đồng bộ
const syncDateModal = ref(false);
const selectedSyncDate = ref(new Date());
const syncParams = ref({ value: 1, type: '', type2: null });

const model = ref([
    {
        label: 'Tổng quan',
        icon: 'pi pi-fw pi-home',
        url: '/'
    },
    {
        label: 'Hàng hoá',
        icon: 'pi pi-fw pi-shopping-cart',
        items: [
            { label: 'Danh mục', url: '/man/Products' },
            { label: 'Nhóm hàng hóa', url: '/man/products-group' },
            {
                label: 'Thiết lập mã giá',
                items: [
                    { label: 'Mã giá', url: '/man/price-code' },
                    { label: 'Bảng mã giá', url: '/man/price-code-table' }
                ]
            },

            { label: 'Đơn vị tính', url: '/man/unit' },
            {
                label: 'Quy tắc giá mua',
                url: '/man/rules-vts'
                // items: [
                //     { label: 'Vàng trang sức',  },
                //     { label: 'Vàng trao đổi', url: '/man/rules-vtd' }
                // ]
            },
            {
                label: 'Quy tắc giá bán',
                url: '/man/gold-jewelry'
            },
            { label: 'Nhóm đơn vị tính', url: '/man/unit-group' },
            {
                label: 'Thiết lập bảo hành',
                items: [
                    { label: 'Bảng dịch vụ bảo hành', url: '/man/warranty-service' },
                    { label: 'Quy tắc tính Hao vàng quy đổi', url: '/man/warranty-setup' }
                ]
            },
            {
                label: 'Bảng giá bán',
                url: '/man/sell-price-list'
            }
        ]
    },
    {
        label: 'Giao dịch',
        icon: 'pi pi-credit-card',
        items: [
            {
                label: 'Bán hàng',
                items: [
                    { label: 'Hoá đơn bán hàng', url: '/man/ar-invoice' },
                    // { label: 'Hoá đơn bán hàng VTS', url: '/man/ar-invoice-gold-jewelry' },
                    { label: 'Đặt hàng', url: '/man/list-order' },
                    { label: 'Đổi trả hàng', url: '/man/export-products' }
                ]
            },
            { label: 'Mua hàng', url: '/man/purchase' },
            { label: 'Bảo hành', url: '/man/guarantee' },
            {
                label: 'Nghiệp vụ kho',
                items: [
                    { label: 'Nhập hàng', url: '/man/import-products' },
                    { label: 'Trả hàng nhập', url: '/man/purchase-returns' },
                    { label: 'Xuất khác', url: '/man/damage-items' },
                    { label: 'Kiểm kê', url: '/man/inventory-check' },
                    {
                        label: 'Điều chuyển',
                        url: '/man/manage-transfer'
                    }
                ]
            },
            { label: 'Kết ca', url: '/man/shifts-report' }
        ]
    },
    {
        label: 'Đối tác',
        icon: 'pi pi-users',
        items: [
            {
                label: 'Khách hàng',
                items: [
                    { label: 'Danh sách KH', url: '/man/customers' },
                    { label: 'Hạng thẻ KH', url: '/man/customers-rank' },
                    { label: 'Danh sách KH cảnh báo', url: '/man/crime' },
                    { label: 'Đối tác voucher/eVoucher', url: '/man/voucher-partner' }
                ]
            },
            {
                label: 'Nhà cung cấp',
                items: [
                    { label: 'Danh sách NCC', url: '/man/vendors' },
                    { label: 'Nhóm NCC', url: '/man/group-vendors' }
                ]
            }
        ]
    },

    {
        label: 'Khuyến mãi',
        icon: ' pi pi-gift',
        items: [
            { label: 'Quản lý CTKM', url: '/man/sale-off' },
            { label: 'Phát hành voucher', url: '/man/voucher-batch' },
            { label: 'Báo cáo voucher', url: '/man/voucher-report' },
            { label: 'Quản lý Coupon', url: '/man/coupon' }
        ]
    },
    {
        label: 'Sổ quỹ',
        icon: 'pi pi-fw pi-wallet',
        url: '/man/cash-book'
    },
    {
        label: 'Báo cáo',
        icon: 'pi pi-fw pi-info-circle',
        items: [
            { label: 'Báo cáo tồn kho', url: '/man/inventory-report' },
            { label: 'Báo cáo tồn kho (chi tiết)', url: '/man/inventory-ledger-report' },
            { label: 'BKTM không hóa đơn VTĐ', url: '/man/purchase-no-invoice' },
            { label: 'BKTM không hóa đơn VTS', url: '/man/purchase-no-invoice-vts' },
            {
                label: 'Báo cáo NHNN',
                items: [
                    { label: 'Báo cáo giao dịch lớn', url: '/man/state-bank-report' },
                    { label: 'Báo cáo vàng miếng', url: '/man/gold-report' }
                ]
            },
            { label: 'Báo cáo tồn tiền', url: '/man/cash-balance-report' },
            { label: 'Công nợ trọng lượng theo đối tượng', url: '/man/partner-weight-report' },
            { label: 'Điều chỉnh công nợ khách hàng', url: '/man/customer-debt-adjustment' },
            { label: 'Báo cáo đồng bộ SAP', url: '/man/sap-sync-report' },
            { label: 'Hàng hoá lưu quầy VTS', url: '/man/counter-stock-aging-report' },

            { label: 'Khách hàng', url: '' },
            { label: 'Nhân viên', url: '' },
            { label: 'Tra cứu serial', url: '/man/searchSerial' }
        ]
    },
    {
        label: 'Bảng giá nguyên liệu',
        icon: 'pi pi-chart-bar',
        items: [
            { label: 'Danh sách bảng giá', url: '/man/price-list' },
            { label: 'Danh sách mã giá', url: '/man/price-list-code' },
            { label: 'Tỷ giá USD', url: '/man/exchange-rate' },
            {
                label: 'Bảng giá hiển thị',

                items: [
                    {
                        label: 'Thiết lập thuơng hiệu',
                        url: '/man/display-brands'
                    },
                    {
                        label: 'Thiết lập bảng giá',
                        url: '/man/display-gold-list'
                    }
                ]
            }
        ]
    },
    {
        label: 'Đồng bộ',
        icon: 'pi pi-sync',
        items: [
            {
                label: '1. Mua hàng',
                items: [
                    { label: ' Tạo phiếu', command: () => handleSync('1.1') },
                    { label: ' Thanh toán', command: () => handleSync('1.2') },
                    { label: ' Hủy tạo phiếu', command: () => handleSync('1.3') },
                    { label: ' Hủy lần 1', command: () => handleSync('1.4') },
                    { label: ' Hủy lần 2', command: () => handleSync('1.5') }
                ]
            },
            {
                label: '2. Bán hàng',
                items: [
                    { label: ' Đã thanh toán', command: () => handleSync('2.1') },
                    { label: ' Đã trả vàng', command: () => handleSync('2.2') },
                    { label: 'Đã hủy thanh toán', command: () => handleSync('2.3') },
                    { label: 'Đã hủy lần 1', command: () => handleSync('2.4') },
                    { label: 'Đã hủy lần 2', command: () => handleSync('2.5') }
                ]
            },
            {
                label: '3. Đặt hàng',
                items: [
                    { label: 'Đặt cọc', command: () => handleSync('3.1') },
                    { label: 'Thanh toán', command: () => handleSync('3.2') },
                    { label: 'Đã trả vàng', command: () => handleSync('3.3') },
                    { label: 'Hủy đặt cọc', command: () => handleSync('3.4') },
                    {
                        label: 'Hủy đặt cọc sau khi update serial',
                        command: () => handleSync('3.5')
                    },
                    { label: 'Hủy đã thanh toán', command: () => handleSync('3.6') },
                    { label: 'Hủy lần 1', command: () => handleSync('3.7') },
                    { label: 'Hủy lần 2', command: () => handleSync('3.8') }
                ]
            },
            {
                label: '4. Đặt hàng',
                items: [
                    {
                        label: 'Vàng trao đổi',
                        items: [
                            {
                                label: 'Đổi hàng Vàng trao đổi không có phiếu chi',
                                command: () => handleSync(4.1)
                            },
                            {
                                label: 'Tạo phiếu đổi hàng Vàng trao đổi có phiếu chi',
                                command: () => handleSync(4.2)
                            },
                            {
                                label: 'Thanh toán phiếu đổi hàng vàng trao đổi có chi',
                                command: () => handleSync(4.3)
                            },
                            { label: 'Hủy lần 1', command: () => handleSync(4.4) },
                            { label: 'Hủy lần 2', command: () => handleSync(4.5) },
                            { label: 'Hủy phiếu không có chi', command: () => handleSync(4.6) },
                            {
                                label: 'Hủy phiếu có chi chưa thanh toán',
                                command: () => handleSync(4.7)
                            }
                        ]
                    },
                    {
                        label: 'Vàng trang sức',
                        items: [
                            { label: 'Tạo phiếu trả vàng VTS', command: () => handleSync(4.8) },
                            { label: 'Thanh toán trả hàng VTS', command: () => handleSync(4.9) },
                            { label: 'Hủy tạo phiếu trả hàng VTS', command: () => handleSync(4.1) },
                            {
                                label: 'Hủy lần 1 phiếu trả hàng VTS',
                                command: () => handleSync(4.11)
                            },
                            {
                                label: 'Hủy lần 2 phiếu trả hàng VTS',
                                command: () => handleSync(4.12)
                            },
                            { label: 'Tạo phiếu đổi hàng VTS', command: () => handleSync(4.13) },
                            { label: 'Thanh toán đổi hàng VTS', command: () => handleSync(4.14) },
                            { label: 'Trả vàng đổi hàng VTS', command: () => handleSync(4.15) },
                            { label: 'Hủy tạo phiếu đổi hàng VTS', command: () => handleSync(4.16) },
                            { label: 'Hủy thanh toán đổi hàng VTS', command: () => handleSync(4.17) },
                            { label: 'Hủy lần 1 đổi hàng VTS', command: () => handleSync(4.18) },
                            { label: 'Hủy lần 2 đổi hàng VTS', command: () => handleSync(4.19) }
                        ]
                    }
                ]
            },
            {
                label: '5. Bảo hành',
                items: [
                    {
                        label: 'Thanh toán',
                        command: () => handleSync('5.1')
                    },
                    {
                        label: 'Huỷ thanh toán',
                        command: () => handleSync('5.2')
                    }
                ]
            },
            {
                label: '6. Thu chi',
                items: [
                    {
                        label: 'Thu chi NCC, KH',
                        command: () => handleSync('6.1')
                    },
                    {
                        label: 'Thu chi Công ty, quầy',
                        command: () => handleSync('6.2')
                    }
                ]
            },
            {
                label: '7. Điều chuyển',
                command: () => handleSync('7.1')
            },
            {
                label: '8. Xuất khác',
                command: () => handleSync('8.1')
            },
            {
                label: '9. Nhập xuất khác',
                command: () => handleSync('9.1')
            },
            {
                label: '10. Nhập xuất khác liên kết',
                command: () => handleSync('10.1')
            }
        ]
    }
]);
const loadingSync = ref(false);
const handleSync = async (value = 1) => {
    // Lưu thông tin đồng bộ và mở popup chọn thời gian
    syncParams.value = { value };
    selectedSyncDate.value = new Date();
    syncDateModal.value = true;
};

// Hàm thực hiện đồng bộ với thời gian đã chọn
const performSync = async () => {
    try {
        loadingSync.value = true;
        const { value } = syncParams.value;
        const newDate = format(selectedSyncDate.value, 'yyyy-MM-dd');
        let param = '';
        switch (value) {
            case '1.1': // Tạo phiếu
                param = `objType=18&statusSync=1`;
                break;
            case '1.2': // Thanh toán
                param = `objType=18&statusSync=2`;
                break;
            case '1.3': // Hủy tạo phiếu
                param = `objType=18&statusSync=3`;
                break;
            case '1.4': // Hủy lần 1
                param = `objType=18&statusSync=4`;
                break;
            case '1.5': // Hủy lần 2
                param = `objType=18&statusSync=5`;
                break;
            case '2.1': // Đã thanh toán
                param = `objType=13&statusSync=1`;
                break;
            case '2.2': // Đã trả vàng
                param = `objType=13&statusSync=2`;
                break;
            case '2.3': // Đã hủy thanh toán
                param = `objType=13&statusSync=3`;
                break;
            case '2.4': // Đã hủy lần 1
                param = `objType=13&statusSync=4`;
                break;
            case '2.5': // Đã hủy lần 2
                param = `objType=13&statusSync=5`;
                break;
            case '3.1': // Đặt cọc
                param = `objType=26&statusSync=1`;
                break;
            case '3.2': // Thanh toán
                param = `objType=26&statusSync=2`;
                break;
            case '3.3': // Đã trả vàng
                param = `objType=26&statusSync=3`;
                break;
            case '3.4': // Hủy đặt cọc
                param = `objType=26&statusSync=4`;
                break;
            case '3.5': // Hủy đặt cọc sau khi update serial
                param = `objType=26&statusSync=5`;
                break;
            case '3.6': // Hủy đã thanh toán
                param = `objType=26&statusSync=6`;
                break;
            case '3.7': // Hủy lần 1
                param = `objType=26&statusSync=7`;
                break;
            case '3.8': // Hủy lần 2
                param = `objType=26&statusSync=8`;
                break;
            case 4.1: // Đổi hàng Vàng trao đổi không có phiếu chi
                param = `objType=19&statusSync=1`;
                break;
            case 4.2: // Tạo phiếu đổi hàng Vàng trao đổi có phiếu chi
                param = `objType=19&statusSync=2`;
                break;
            case 4.3: // Thanh toán phiếu đổi hàng vàng trao đổi có chi
                param = `objType=19&statusSync=3`;
                break;
            case 4.4: // Hủy lần 1
                param = `objType=19&statusSync=16`;
                break;
            case 4.5: // Hủy lần 2
                param = `objType=19&statusSync=17`;
                break;
            case 4.6: // Hủy phiếu không có chi
                param = `objType=19&statusSync=18`;
                break;
            case 4.7: // Hủy phiếu có chi chưa thanh toán
                param = `objType=19&statusSync=19`;
                break;
            case 4.8: // Tạo phiếu trả vàng VTS
                param = `objType=19&statusSync=4`;
                break;
            case 4.9: // Thanh toán trả hàng VTS
                param = `objType=19&statusSync=5`;
                break;
            case 4.1: // Hủy tạo phiếu trả hàng VTS
                param = `objType=19&statusSync=6`;
                break;
            case 4.11: // Hủy lần 1 phiếu trả hàng VTS
                param = `objType=19&statusSync=7`;
                break;
            case 4.12: // Hủy lần 2 phiếu trả hàng VTS
                param = `objType=19&statusSync=8`;
                break;
            case 4.13: // Tạo phiếu đổi hàng VTS
                param = `objType=19&statusSync=9`;
                break;
            case 4.14: // Thanh toán đổi hàng VTS
                param = `objType=19&statusSync=10`;
                break;
            case 4.15: // Trả vàng đổi hàng VTS
                param = `objType=19&statusSync=11`;
                break;
            case 4.16: // Hủy tạo phiếu đổi hàng VTS
                param = `objType=19&statusSync=12`;
                break;
            case 4.17: // Hủy thanh toán đổi hàng VTS
                param = `objType=19&statusSync=13`;
                break;
            case 4.18: // Hủy lần 1 đổi hàng VTS
                param = `objType=19&statusSync=14`;
                break;
            case 4.19: // Hủy lần 2 đổi hàng VTS
                param = `objType=19&statusSync=15`;
                break;
            case '5.1': // Thanh toán
                param = `objType=88&statusSync=6`;
                break;
            case '5.2': // Huỷ thanh toán
                param = `objType=88&statusSync=7`;
                break;
            case '6.1': // Thu chi NCC, KH
                param = `objType=66&statusSync=1`;
                break;
            case '6.2': // Thu chi Công ty, quầy
                param = `objType=66&statusSync=2`;
                break;
            case '7.1': // Điều chuyển
                param = `objType=67&statusSync=2`;
                break;
            case '8.1': // Xuất khác
                param = `objType=27&statusSync=1`;
                break;
            case '9.1': // Nhập xuất khác
                param = `objType=20&statusSync=1`;
                break;
            case '10.1': // Nhập xuất khác liên kết
                param = `objType=20&statusSync=2`;
                break;
            default:
                break;
        }
        if (!param) {
            proxy.$notify('W', 'Không có trường hợp này', toast);
            return;
        }
        await axios.post(`${API_URL}?DocDate=${newDate}&${param}`);
        proxy.$notify('S', 'Đồng bộ thành công', toast);
        syncDateModal.value = false;
    } catch (error) {
        console.log(error);
        proxy.$notify('E', error.response?.data?.message || error.response?.data?.errors || 'Đồng bộ thất bại', toast);
    } finally {
        loadingSync.value = false;
    }
};
</script>

<template>
    <Menubar :model="model" class="bg-primary" style="border-radius: 0px !important" />
    <ExportModal v-model="exportModal" :totalRecords="totalRecords"></ExportModal>

    <!-- Popup chọn thời gian đồng bộ -->
    <Dialog v-model:visible="syncDateModal" modal position="top" :draggable="false" header="Chọn thời gian đồng bộ" :style="{ width: '400px' }">
        <div class="flex flex-column gap-3">
            <div class="flex flex-column gap-2">
                <label for="syncDate">Chọn ngày đồng bộ:</label>
                <Calendar id="syncDate" v-model="selectedSyncDate" showIcon iconDisplay="input" dateFormat="dd/mm/yy" placeholder="Chọn ngày" :maxDate="new Date()" />
            </div>
            <div class="text-sm text-gray-600">Hệ thống sẽ thực hiện đồng bộ dữ liệu cho ngày đã chọn.</div>
        </div>
        <template #footer>
            <div class="flex justify-content-end gap-2">
                <Button type="button" label="Hủy" severity="secondary" @click="syncDateModal = false"></Button>
                <Button type="button" label="Đồng bộ" @click="performSync()" :loading="loadingSync"></Button>
            </div>
        </template>
    </Dialog>

    <Loading v-if="loadingSync" />
</template>

<style lang="scss">
.p-menubar {
    border: unset;
}

.p-menubar .p-menubar-root-list > .p-menuitem > .p-menuitem-content .p-menuitem-link .p-menuitem-text {
    color: #fff;
}

.p-menubar .p-menubar-root-list > .p-menuitem:not(.p-highlight):not(.p-disabled) > .p-menuitem-content:hover {
    color: #fff;
    background: var(--primary-color);
}

.p-menubar .p-menuitem.p-highlight > .p-menuitem-content {
    background: var(--primary-color);
}

.p-menubar .p-menubar-root-list > .p-menuitem:not(.p-highlight):not(.p-disabled) > .p-menuitem-content:hover .p-menuitem-link .p-menuitem-icon,
.p-menubar .p-menubar-root-list > .p-menuitem:not(.p-highlight):not(.p-disabled) > .p-menuitem-content:hover .p-submenu-icon {
    color: #fff;
}

.p-menubar .p-menuitem > .p-menuitem-content .p-menuitem-link {
    color: #fff;
    padding: 0.5rem 0.75rem;
    user-select: none;
}

.p-menubar .p-menubar-root-list > .p-menuitem > .p-menuitem-content .p-menuitem-link .p-submenu-icon {
    color: #fff;
    margin-left: 0.5rem;
}

.p-menubar .p-menubar-root-list > .p-menuitem > .p-menuitem-content .p-menuitem-link .p-menuitem-icon {
    color: #fff;
    margin-right: 0.5rem;
}

.p-menubar .p-submenu-list {
    padding: 0.25rem 0.25rem;
    background: var(--primary-color);
    border: unset;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
    min-width: 14.5rem;
    border-radius: 6px;
    z-index: 999999;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

.p-menubar .p-menuitem > .p-menuitem-content .p-menuitem-link .p-menuitem-icon {
    color: #fff;
    margin-right: 0.5rem;
}

.p-menubar .p-menuitem > .p-menuitem-content .p-menuitem-link .p-menuitem-text {
    color: #fff;
}

.p-menubar .p-menuitem > .p-menuitem-content .p-menuitem-link .p-submenu-icon {
    color: #fff;
}

.p-menubar .p-menuitem:not(.p-highlight):not(.p-disabled) > .p-menuitem-content:hover {
    color: #fff;
    background: var(--highlight-text-color);
}

.p-menubar .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus > .p-menuitem-content {
    background: var(--highlight-text-color);
}

.p-menubar-root-list {
    padding-left: 4rem;
}
</style>
